"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const basic_1 = require("orbiter-core/src/basic");
const DatabaseController_1 = require("orbiter-core/src/databasecontroller/DatabaseController");
const DataController_1 = require("orbiter-core/src/datastructures/DataController");
const exceptions_1 = require("orbiter-core/src/exceptions");
const apicommunication_1 = require("./apicommunication");
var ConstructionMethods;
(function (ConstructionMethods) {
    ConstructionMethods[ConstructionMethods["PromiseToRetrieve"] = 0] = "PromiseToRetrieve";
    ConstructionMethods[ConstructionMethods["Data"] = 1] = "Data";
})(ConstructionMethods = exports.ConstructionMethods || (exports.ConstructionMethods = {}));
/**
 * To implement on class level:
 *
 *      methods:
 *          - parseFromDictionary
 *          - getBaseEndpoint
 *          - getApiKey
 *          - getPluralApiKey
 */
class ApiController extends DatabaseController_1.default {
    /**
     * Defaults to lazy construction method.
     *
     * @param {} id
     * @param {ConstructionMethods} constructionMethod
     * @param {T} data?
     */
    constructor(id, constructionMethod = ConstructionMethods.Data, data) {
        super(id);
        this.retrieving = false;
        this.retrieved = false;
        switch (constructionMethod) {
            case ConstructionMethods.Data: {
                this.data = data;
                this.retrieved = true;
                break;
            }
        }
    }
    /**
     * Has to be implemented on class level.
     *
     * @returns {string}
     */
    static getBaseEndpoint() {
        throw exceptions_1.NOT_IMPLEMENTED_EXCEPTION;
    }
    /**
     * Could be implemented on class level.
     *
     * @returns {string}
     */
    static getCreateEndpoint() {
        return this.getBaseEndpoint() + "/create";
    }
    /**
     * Could be implemented on class level.
     *
     * @returns {string}
     */
    static getUpdateEndpoint() {
        return this.getBaseEndpoint() + "/update";
    }
    /**
     * Could be implemented on class level.
     *
     * @returns {string}
     */
    static getDeleteEndpoint() {
        return this.getBaseEndpoint() + "/delete";
    }
    /**
     * Could be implemented on class level.
     *
     * @returns {string}
     */
    static getArchiveEndpoint() {
        return this.getBaseEndpoint() + "/archive";
    }
    /**
     * Could be implemented on class level.
     *
     * @returns {string}
     */
    static getRetrieveEndpoint() {
        return this.getBaseEndpoint() + "/retrieve";
    }
    /**
     * Could be implemented on class level.
     *
     * @returns {string}
     */
    static getRetrieveAllEndpoint() {
        return this.getBaseEndpoint() + "/retrieve/all";
    }
    /**
     * Has to be implemented on class level.
     *
     * @returns {string}
     */
    static getApiKey() {
        throw exceptions_1.NOT_IMPLEMENTED_EXCEPTION;
    }
    /**
     * Could be implemented on class level.
     *
     * @returns {string}
     */
    static getPluralApiKey() {
        return this.getApiKey() + "s";
    }
    // ---
    // CRUD operations
    // ---
    // TODO: error handling
    /**
     * Given data is expected to be valid.
     * @param {DataController} data
     * @returns {Promise<any>}
     */
    static create(data, quiet = true) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: can this be done better than <any>? With some sort of generics?
            const dataDict = yield data.asDict();
            return new Promise((resolve, reject) => {
                apicommunication_1.doJsonApiCall(this.getCreateEndpoint(), dataDict, (result) => {
                    const apiController = new this(result[this.getApiKey()]._id, ConstructionMethods.Data, result[this.getApiKey()]);
                    resolve(apiController);
                }, quiet, reject);
            });
        });
    }
    /**
     * Given data is expected to be valid.
     */
    static createMultiple(data, quiet = true) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: can this be done better than <any>? With some sort of generics?
            const dataDict = {};
            dataDict[this.getPluralApiKey()] = yield Promise.all(data.map((d) => __awaiter(this, void 0, void 0, function* () { return yield d.asDict(); })));
            return new Promise((resolve, reject) => {
                apicommunication_1.doJsonApiCall(this.getCreateEndpoint(), dataDict, (result) => {
                    const apiController = new this(result[this.getApiKey()]._id, ConstructionMethods.Data, result[this.getApiKey()]);
                    resolve(apiController);
                }, quiet, reject);
            });
        });
    }
    static retrieveAll(quiet = true) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, reject) => {
                apicommunication_1.doJsonGetApiCall(this.getRetrieveAllEndpoint(), (result) => __awaiter(this, void 0, void 0, function* () {
                    const listOfResults = result[this.getPluralApiKey()];
                    const output = [];
                    for (const res of listOfResults) {
                        const apiController = new this(res._id, ConstructionMethods.PromiseToRetrieve);
                        yield apiController.parseFromDictionary(res);
                        output.push(apiController);
                    }
                    resolve(output);
                }), quiet, reject);
            });
        });
    }
    static retrieve(id) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: can this be done better than <any>? With some sort of generics?
            if (!basic_1.isValidId(id)) {
                throw exceptions_1.ID_EXCEPTION;
            }
            const r = new this(id, ConstructionMethods.PromiseToRetrieve);
            yield r.retrieve();
            return r;
        });
    }
    static clone(apiController) {
        // TODO: can this be done better than any With some sort of generics?
        const dataClone = apiController.isRetrieved() ? apiController.getData().clone() : apiController.getData();
        return new this(apiController.getId(), ConstructionMethods.Data, dataClone);
    }
    setId(id) {
        super.setId(id);
    }
    /**
     * Given data is expected to be valid.
     *
     * @param {string} property
     * @param value
     * @returns {Promise<void>}
     */
    updateProperty(property, value) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: can this be done better than <any>? With some sort of generics?
            return new Promise((resolve, reject) => {
                apicommunication_1.doJsonApiCall(this.getClass().getUpdateEndpoint() + "/" + property.toLowerCase() + "/" + this.getId().toString(), { [property]: value }, (result) => __awaiter(this, void 0, void 0, function* () {
                    yield this.parseFromDictionary(result[this.getClass().getApiKey()]);
                    resolve();
                }));
            });
        });
    }
    updateEntirely(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const d = yield data.asDict();
            return new Promise((resolve, reject) => {
                apicommunication_1.doJsonApiCall(this.getClass().getUpdateEndpoint() + "/" + this.getId().toString(), d, (result) => __awaiter(this, void 0, void 0, function* () {
                    yield this.parseFromDictionary(result[this.getClass().getApiKey()]);
                    resolve();
                }));
            });
        });
    }
    pushUpdate() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.updateEntirely(this.getData());
        });
    }
    delete() {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: can this be done better than <any>? With some sort of generics?
            return new Promise((resolve, reject) => {
                apicommunication_1.doJsonDeleteApiCall(this.getClass().getDeleteEndpoint() + "/" + this.getId().toString(), (result) => {
                    resolve();
                });
            });
        });
    }
    archive() {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: can this be done better than <any>? With some sort of generics?
            return new Promise((resolve, reject) => {
                apicommunication_1.doJsonDeleteApiCall(this.getClass().getArchiveEndpoint() + "/" + this.getId().toString(), (result) => {
                    resolve();
                });
            });
        });
    }
    getData() {
        return this.data;
    }
    setData(data) {
        this.data = data;
        this.retrieved = true;
    }
    isRetrieved() {
        return this.retrieved;
    }
    isRetrieving() {
        return this.retrieving;
    }
    /**
     * Method that can parse database representation and apply this to the current object.
     * Has to be implemented on class level.
     *
     * @param dictionary
     */
    parseFromDictionary(dictionary) {
        return __awaiter(this, void 0, void 0, function* () {
            throw exceptions_1.NOT_IMPLEMENTED_EXCEPTION;
        });
    }
    retrieve() {
        return __awaiter(this, void 0, void 0, function* () {
            this.retrieving = true;
            const res = yield new Promise((resolve, reject) => {
                apicommunication_1.doJsonGetApiCall(this.getClass().getRetrieveEndpoint() + "/" + this.getId().toString(), (result) => {
                    resolve(result[this.getClass().getApiKey()]);
                });
            });
            yield this.parseFromDictionaryRunner(res);
            this.retrieved = true;
            this.retrieving = false;
        });
    }
    retrieveIfNot() {
        return __awaiter(this, void 0, void 0, function* () {
            // If retrieved, don't do anything
            if (this.isRetrieved()) {
                return;
            }
            // If not yet retrieved, retrieve
            yield this.retrieve();
        });
    }
    asDict() {
        const _super = Object.create(null, {
            asDict: { get: () => super.asDict }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getData();
            return yield _super.asDict.call(this);
        });
    }
    parseFromDictionaryRunner(dictionary) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.parseFromDictionary(dictionary);
        });
    }
    getClass() {
        return this.constructor;
    }
}
__decorate([
    DataController_1.default.mergedDataProperty()
], ApiController.prototype, "data", void 0);
exports.default = ApiController;
//# sourceMappingURL=ApiController.js.map